/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

export default function Checkbox (theme) {
    return {
        MuiCheckbox: {
            styleOverrides: {
                root: {
                    color: theme.palette.secondary[300],
                },
            },
        },
    };
}
